module.exports = __webpack_public_path__ + "static/img/S108-90W_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/S108-90W_1.png
// module id = pZlQ
// module chunks = 0